const initialState = (function(state={}) {
	if (typeof(state) === "string") {
		var features = state.split(",");
		
		state = {
			media_information: false,
			likes: false,
			like: false,
			switch_instance: false,
			chart: false,
			media: true,
			metadata: true,

			add_public: false,
			add_personal: false,
			add_feedback: false,
			add_course: false,

			update_created_public: false,
			update_samesource_public: false,
			update_all_public: false,
			update_created_personal: false,
			update_samesource_personal: false,
			update_all_personal: false,
			update_created_feedback: false,
			update_samesource_feedback: false,
			update_all_feedback: false,
			update_created_course: false,
			update_samesource_course: false,
			update_all_course: false,

			delete_created_public: false,
			delete_samesource_public: false,
			delete_all_public: false,
			delete_created_personal: false,
			delete_samesource_personal: false,
			delete_all_personal: false,
			delete_created_feedback: false,
			delete_samesource_feedback: false,
			delete_all_feedback: false,
			delete_created_course: false,
			delete_samesource_course: false,
			delete_all_course: false,

			view_all_public: false,
			view_created_public: false,
			view_all_personal: false,
			view_created_personal: false,
			view_all_feedback: false,
			view_created_feedback: false,
			view_all_course: false,
			view_created_course: false,

			download_comments: false,
			download_media: false,
			download_commenthistory: false,
			download_likehistory: false
		};

		for (var i=0; i<features.length; i++) {
			state[features[i]] = true;
		}
	}

	state.comments =
		state.view_all_public === true ||
		state.view_created_public === true ||
		state.view_all_personal === true ||
		state.view_created_personal === true ||
		state.view_all_feedback === true ||
		state.view_created_feedback === true ||
		state.view_all_course === true ||
		state.view_created_course === true;

	return state;
})(window.commentstate.features);

export default function(state=initialState, action) {
	return state;
}